// hbsfy compiled Handlebars template
var HandlebarsCompiler = require('hbsfy/runtime');
module.exports = HandlebarsCompiler.template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div id=\"lightset-wizard-top-row-region\" class=\"lightset-wizard__feature-row\"></div>\n<div id=\"lightset-wizard-bottom-row-region\" class=\"lightset-wizard__feature-row\"></div>\n";
},"useData":true});
